<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/anze-product.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>前海1-4类雇主险</h2>
					<div style="color: red">行业超低价 | 全线上操作 | 可扩展伤残10%</div>
					<p>
						① 投保简便支持月单
						<br />
						② 社保用药100%赔付
						<br />
						③ 3人起保，最高可保100万
						<br />
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 25px"
						type="text"
						@click.native="handleDownLoad">
						下载前海雇主险职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<el-row style="margin-bottom: 15px; margin-left: 10px">
						<el-col :span="8">
							档次：
							<el-select v-model="priceRate" placeholder="请选择档次" @change="onChangePriceRate">
								<el-option
									v-for="item in priceRateList"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-col>
						<el-col :span="8">
							扩展方案：
							<el-select v-model="kuozhanRate" placeholder="请选择扩展方案" @change="onChangeKuozhanRate">
								<el-option
									v-for="item in kuozhanRateList"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-col>
					</el-row>
					<avue-crud
						ref="crud"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>

									<span v-if="qa.question === '该保险方案是否可以保高空？'" style="white-space: pre-wrap">
										本保险方案
										<span class="red-bold">不承保高处作业时发生的意外事故</span>
										，因高空作业导致的任何损失，保险公司不承担赔偿责任。所谓高处作业是指人在一定位置为基准的高处进行的作业。
										<span class="red-bold">
											国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。
										</span>
									</span>

									<span v-else-if="qa.question === '该保险方案责任范围包括哪些？'" style="white-space: pre-wrap">
										在保险期间内，被保险人的
										<span class="red-bold">雇员</span>
										在受雇过程中从事被保险人的业务工作而遭受意外伤害或罹患国家规定的职业病所致伤残或死亡，符合国务院颁布的《工伤保险条例》规定可认定为工伤的以下情形，依照中华人民共和国法律（不包括港澳台地区，下同）应由被保险人承担的经济赔偿责任，保险人按照本保险合同约定负责赔偿：
										（一）在工作时间和工作场所内，因工作原因受到事故伤害；
										（二）工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作受到事故伤害；
										（三）在工作时间和工作场所内，因履行工作职责受到暴力等意外伤害； （四）患职业病；
										（五）因工外出期间，由于工作原因受到伤害或者发生事故下落不明； （六）在上下班途中，
										<span class="red-bold">受到非本人主要责任的交通事故</span>
										或者城市轨道交通、客运轮渡、火车事故伤害；
										（七）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡；
										（八）在抢险救灾等维护国家利益、公共利益活动中受到伤害；
										（九）原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到用人单位后旧伤复发；
										（十）法律、行政法规规定应当认定为工伤的其他情形。
									</span>
									<span
										v-else-if="qa.question === '有哪些损失、费用和责任，该保险方案不赔偿？'"
										style="white-space: pre-wrap">
										以下损失、费用和责任，该保险方案不赔偿。
										（一）被保险人应该承担的合同责任，但无合同存在时仍然应由被保险人承担的经济赔偿责任不在此限；
										（二）罚款、罚金及惩罚性赔偿； （三）
										<span class="red-bold">精神损害赔偿；</span>
										（四）间接损失； （五）除另有约定外，在中华人民共和国境外所发生的雇员的伤残或死亡； （六）
										<span class="red-bold">
											超出雇员所在地工伤保险诊疗项目目录、工伤保险药品目录、工伤保险住院服务标准的医疗费用；
										</span>
										（七）
										<span class="red-bold">工伤保险已经支付的费用；</span>
										（八）雇员在中华人民共和国境外（包括港、澳、台地区）发生的人身伤亡；
										（九）被保险人对其承包商的雇员的赔偿责任； （十）
										<span class="red-bold">
											陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具等费用；
										</span>
										（十一）本保险合同中载明的免赔额。
									</span>
									<span v-else-if="qa.question === '哪些职业可保？'" style="white-space: pre-wrap">
										本保单可承保1-4类职业：餐饮业（不含外卖送餐、跑腿代购人员）、旅游业/商业、服务业/物业/家政服务/
										<span class="red-bold">室内装修、室内保洁</span>
										、室内电器安装（不含空调）/能源开发利用业/纺织及纺织制品业，具体职业以《前海财险职业类别分类表》为准。
									</span>
									<span v-else-if="qa.question === '哪些职业不保？'" style="white-space: pre-wrap">
										本方案拒绝承保职业：农畜渔牧业/木材森林业/矿业采石业/交通运输业/建筑工程业（
										<span class="red-bold">不含室内项目</span>
										)/职业运动员/娱乐业/公共事业/家用空调安装/电梯行业/军人/金属冶炼/高压电相关职业/水泥石膏石灰行业/化工制造行业/火药、炸药、烟花业/邮政/快递、窑炉/烟囱建设及拆除、石油天然气开发、危险品/危化品、家具/家私业、船舶/造船业。
									</span>
									<span style="white-space: pre-wrap">{{ qa.answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>
						<p style="line-height: 32px">
							1. 本保险适用以下保险条款：
							<span>
								<a
									href="https://mbtest.meibaokeji.com.cn/employer/static/2022images/pdf/qianhai.pdf"
									style="color: DodgerBlue"
									target="_blank">
									新疆前海联合财产保险股份有限公司雇主责任保险条款
								</a>
								，备案编号为：(前海财险)(备-责任保险)【2019】(主) 014号
							</span>
							<br />
							2、本保险由新疆前海联合财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。
							<br />
							3、保险公司全国统一的客户服务及投诉方式详见链接：
							<span>
								<a
									href="https://www.qhins.com/cms/statics/complaintProcess.html"
									style="color: DodgerBlue"
									target="_blank">
									全国统一的客户服务及投诉方式
								</a>
							</span>
							<br />
							4、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
							<br />
							5、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
							<br />
							6、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							7、本保险根据投保单位的需求提供电子发票或纸质专票。
							<br />
							8、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
						</p>
						<el-divider></el-divider>
						<h3>特别约定</h3>
						<p style="line-height: 32px">
							1、鉴于被保险人营业性质包括
							<span class="red-bold">
								个体工商户等形式，本保险所指的工作人员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员等
							</span>
							。被保险人雇员年龄范围为16周岁-65周岁（
							<span class="red-bold">截至65岁生日当天</span>
							），不在本年龄段范围内，所发生的事故，保险人均不承担保险责任。
							<br />
							2、被保险人雇员遭受意外伤害时，实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，如仍在保险人承保职业类别范围内，则保险人对按保单约定的应承担的保险责任，绝对免赔率为损失金额的20%，
							<span class="red-bold">并且</span>
							，投保人需补交对应的保费；如非在承保职业类别范围内，则不予赔付。若投保职业对应的保费，大于或等于被保险人实际职业类别对应的保费，保险人不得以投保职业有误而拒赔或者减少承担赔偿责任。
							<br />
							3、本保单记名投保，本项目所有保单可加人（不足1个月的按1个月收费），不可减人。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。换人规则：原1-2类职业人员可替换为新的1-2类职业人员；原3类职业人员可替换为新的3类职业人员；原4类职业人员可替换为新的4类职业人员；不同职业人员之间不可互换。已发生理赔的人员不可以被更换。
							<br />
							4、本保单雇员必须与被保险人存在实际雇佣关系，否则，保险人有权拒绝赔偿。本保单不承保承揽关系。
							<br />
							5、被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金，在不超过保单列明的每人死亡赔偿限额内赔付。
							<br />
							6、①
							<span class="red-bold">若不扩展伤残赔偿比例十级标准</span>
							，如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金限额=每人伤残赔偿限额*伤残等级对应的赔付比例。本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）进行伤残等级鉴定，一级到十级伤残的比例分别为：100%，80%，70%，60%，50%，40%，30%，
							<span class="red-bold">20%，10%，5%。</span>
							<br />
							②
							<span class="red-bold">若扩展伤残赔偿比例十级标准</span>
							，如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金限额=每人伤残赔偿限额*伤残等级对应的赔付比例。本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）进行伤残等级鉴定，一级到十级伤残的比例分别为：100%，80%，70%，60%，50%，40%，30%，
							<span class="red-bold">25%，15%，10%。</span>
							<br />

							7、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内。按社保内用药100%赔付。按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。被保险人均应在二级以上（含二级）公立医院或保险人认可的医疗机构就诊。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。
							<br />
							但以下地区或指定医疗机构发生的费用不在赔偿范围内：
							<br />
							①以下地区的所有医疗机构发生的费用不在赔偿范围内:
							<br />
							北京平谷区、密云县、怀柔区；
							<span class="red-bold">河北省三河市、沧州市、河北青龙县、廊坊市；天津市</span>
							；辽宁铁岭；江苏徐州、南通、
							<span class="red-bold">连云港、常州</span>
							；山东德州、禹城市、临沂、山东金乡县；河南信阳市；湖北黄冈市、荆州市；四川宜宾市；
							<br />
							②以下医疗机构发生的费用不在赔偿范围内：
							<br />
							四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、河南省新乡市中医院、吉林省四平市第一人民医院、吉林省四平市梨树县第一人民医院、吉林省四平市中医医院、中国医科大学附属盛京医院、山东省莱州市人民医院、山东齐鲁医院、莱州市中医院、莱州市郭家店中心卫医院、山东滨州市中心医院。河北省保定市第一医院.
							<br />
							以上地区的医院和指定的医院均不在保险公司认可医院范围内，即上述的医疗机构的发票保险公司不予理赔。
							<br />

							8、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
							<br />
							9、
							<span class="red-bold">本保单不承保高处作业时发生的意外事故</span>
							，因高空作业导致的任何损失，保险公司不承担赔偿责任。所谓高处作业是指人在一定位置为基准的高处进行的作业。国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。
							<br />
							10、被保险人雇员如果有工伤保险的，则由工伤保险先行赔付，此保单再补充赔付。
							<br />
							11、在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡,保险人承担赔偿责任，赔款限额=每人身故赔偿限额*20%，且该赔偿金额包含在身故赔偿限额范围内。但雇员因
							<span class="red-bold">职业病以外的</span>
							疾病、分娩、流产原因
							<span class="red-bold">以及因上述原因接受医疗、诊治</span>
							不在保单赔偿责任范围内。
							<br />
							12、在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							<br />
							13、
							<span style="font-weight: bold">
								本保单可承保1-4类职业：餐饮业（不含外卖送餐、跑腿代购人员）、旅游业/商业、服务业/
								<span class="red-bold">物业/家政服务/室内装修、室内保洁</span>
								、室内电器安装（不含空调）/
								<span class="red-bold">能源开发利用业</span>
								/纺织及纺织制品业 ，具体职业以《前海财险职业类别分类表》为准。
							</span>
							<br />
							14、被保险人拒保职业范围：农畜渔牧业/木材森林业/矿业采石业/交通运输业/建筑工程业（
							<span class="red-bold">不含室内项目</span>
							）/职业运动员/娱乐业/公共事业/家用空调安装/电梯行业/军人/金属冶炼/高压电相关职业/水泥石膏石灰行业/化工制造行业/火药、炸药、烟花业/邮政/快递、窑炉/烟囱建设及拆除、石油天然气开发、危险品/危化品、家具/家私业、船舶/造船业。
							<br />
							15、
							<span style="font-weight: bold">
								被保险人的雇员无有效驾驶证驾驶机动车或无国家有关部门核发的有效资格证书而使用各种专用机械、
								<span style="color: red">特种设备</span>
								、特种车辆或类似设备装置发生意外事故导致伤害，
								<span style="color: red">不在保单赔偿范围内。</span>
							</span>
							<br />
							16、一旦发生保险事故，被保险人应在事故发生48小时内及时通过保险公司服务热线4008110110，并书面说明事故发生的原因、经过和损失情况；因延迟报案影响保险人查勘、定损的，保险人对无法核实部分不承担任何赔偿责任。
							<br />
							17、
							<span style="font-weight: bold">
								本保单禁止承保以下地区业务：
								<span style="color: red">
									黑龙江、辽宁、吉林、新疆、西藏、青海、宁夏、甘肃、天津、河北、山东荣成、山东青岛、北京平谷区、北京密云区
								</span>
								。对于在被保险人实际用人所在地在以上地区的，保险公司不承担赔偿责任。
							</span>
							<br />
							18、
							<span style="font-weight: bold">法律费用每次事故赔偿限额10万，累计赔偿限额10万。</span>
							<br />
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import {optionPlanQh} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product45Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: this.deepClone(optionPlanQh),

			priceRate: 1,
			priceRateList: [
				{
					label: '1档',
					value: 1,
				},
				{
					label: '2档',
					value: 2,
				},
			],
			kuozhanRate: 1,
			kuozhanRateList: [
				{
					label: '否',
					value: 1,
				},
				{
					label: '是',
					value: 2,
				},
			],
			dataPlan: [],
			dataPlanTemp: [
				{
					insuredItem: '每人死亡赔偿限额',
					plan1: '30万',
					plan2: '40万',
					plan3: '50万',
					plan4: '60万',
					plan5: '70万',
					plan6: '80万',
					plan7: '90万',
					plan8: '100万',
				},
				{
					insuredItem: '每人伤残赔偿限额',
					plan1: '30万',
					plan2: '40万',
					plan3: '50万',
					plan4: '60万',
					plan5: '70万',
					plan6: '80万',
					plan7: '90万',
					plan8: '100万',
				},
				{
					insuredItem: '每人医疗费赔偿限额',
					plan1: '3万',
					plan2: '4万',
					plan3: '5万',
					plan4: '6万',
					plan5: '7万',
					plan6: '8万',
					plan7: '10万',
					plan8: '20万',
				},
				{
					insuredItem: '每人误工费赔偿限额（元/天）',
					plan1: '100元/天',
				},
				{
					insuredItem: '法律费用累计赔偿限额',
					plan1: '10万',
				},
				{
					insuredItem: '法律费用每次事故赔偿限额',
					plan1: '10万',
				},
			],
			priceData1: [
				{
					insuredItem: '1-2类职业（元/年）',
					plan1: 140,
					plan2: 180,
					plan3: 230,
					plan4: 270,
					plan5: 320,
					plan6: 360,
					plan7: 404,
					plan8: 450,
				},
				{
					insuredItem: '3类职业（元/年）',
					plan1: 180,
					plan2: 220,
					plan3: 280,
					plan4: 340,
					plan5: 390,
					plan6: 440,
					plan7: 545,
					plan8: 600,
				},
				{
					insuredItem: '4类职业（元/年）',
					plan1: 300,
					plan2: 360,
					plan3: 396,
					plan4: 468,
					plan5: 550,
					plan6: 620,
					plan7: 725,
					plan8: 810,
				},
			],
			priceData2: [
				{
					insuredItem: '1-2类职业（元/年）',
					plan1: 165,
					plan2: 210,
					plan3: 270,
					plan4: 315,
					plan5: 370,
					plan6: 420,
					plan7: 470,
					plan8: 520,
				},
				{
					insuredItem: '3类职业（元/年）',
					plan1: 210,
					plan2: 260,
					plan3: 325,
					plan4: 400,
					plan5: 450,
					plan6: 510,
					plan7: 630,
					plan8: 700,
				},
				{
					insuredItem: '4类职业（元/年）',
					plan1: 350,
					plan2: 420,
					plan3: 460,
					plan4: 550,
					plan5: 640,
					plan6: 720,
					plan7: 840,
					plan8: 940,
				},
			],

			dataQA: [
				{
					question: '该保险方案的承保保险公司是？',
					answer:
						'由新疆前海联合财产保险股份有限公司（简称“前海财险”）承保。前海财险是一家经营区域覆盖全国，注册资本10亿元，总部位于深圳前海蛇口自贸区的全国性财产保险公司。',
				},
				{
					question: '该保险方案中，哪些单位可作为投保人、被保险人？',
					answer:
						'凡中华人民共和国境内依法设立的企业、事业单位、社会团体、民办非企业单位、基金会、律师事务所、会计师事务所等组织、有雇工的个体工商户，均可作为本保险合同的投保人和被保险人',
				},
				{
					question: '该保险方案中，被保险人与雇员关系怎么定义？',
					answer:
						'本保险所指的工作人员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员等。被保险人雇员年龄范围为16周岁-65周岁（截至65岁生日当天）。',
				},
				{
					question: '该保险方案是否可以保高空？',
					answer:
						'本保险方案不承保高处作业时发生的意外事故，因高空作业导致的任何损失，保险公司不承担赔偿责任。所谓高处作业是指人在一定位置为基准的高处进行的作业。国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。',
				},
				{
					question: '该保险方案责任范围包括哪些？',
					answer: '',
				},
				{
					question: '该保险方案哪些原因造成的损失、费用和责任，该保险方案不赔偿？',
					answer:
						'以下原因造成的损失、费用和责任，该保险方案不赔偿。\n' +
						'（一）投保人、被保险人及其代表的故意行为、重大过失行为；\n' +
						'（二）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动；\n' +
						'（三）核辐射、核爆炸、核污染及其他放射性污染；\n' +
						'（四）大气污染、土地污染、水污染及其他各种污染；\n' +
						'（五）行政行为或司法行为；\n' +
						'（六）雇员的故意行为、犯罪行为或违法行为；\n' +
						'（七）雇员因职业病以外的疾病、传染病、分娩、流产以及因上述原因接受医疗、诊治；\n' +
						'（八）雇员自残、自伤、自杀、打架、斗殴及无合法有效驾驶证照驾驶各种机动车辆；\n' +
						'（九）雇员因非职业原因而受酒精或药剂的影响。',
				},
				{
					question: '有哪些损失、费用和责任，该保险方案不赔偿？',
					answer: '',
				},
				{
					question: '哪些职业可保？',
					answer: '',
				},
				{
					question: '哪些职业不保？',
					answer: '',
				},
				{
					question: '如果投保，无对应职业可选择，应如何处理？',
					answer: '请咨询平台工作人员，由专业客服为您解答。否则，保险人可能拒保。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer: '直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→线上支付保费→获取保单。',
				},
				{
					question: '保单和发票怎么获取？',
					answer: '线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，如果选择专票则通过快递寄送。',
				},
				{
					question: '保单如何查验真伪？',
					answer: '可以通过拨打前海财险全国客服电话4008110110进行人工查询。',
				},
				{
					question: '雇员变动怎么办？',
					answer:
						'本项目所有保单可加人（不足1个月的按1个月收费），不可减人。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。换人规则：原1-2类职业人员可替换为新的1-2类职业人员；原3类职业人员可替换为新的3类职业人员；原4类职业人员可替换为新的4类职业人员；不同职业人员之间不可互换。已发生理赔的人员不可以被更换。',
				},
				{
					question: '出险员工是否可替换出去？',
					answer: '不可以。',
				},
			],
			isDownLoading: false,
		}
	},
	mounted() {
		this.dealPrice()
	},
	methods: {
		//处理钱
		dealPrice() {
			let tempCenter1 = {
				insuredItem: '是否扩展伤残赔偿比例十级标准',
			}
			let tempCenter = {}
			if (this.kuozhanRate === 1) {
				tempCenter1.plan1 = '否'
				tempCenter = {
					insuredItem: '不扩展伤残赔偿比例十级标准',
					plan1:
						'本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T 16180-2014）进行伤残等级鉴定，给付比例一级到十级分别为：100%，80%，70%，60%，50%，40%，30%，20%，10%，5%',
				}
			} else {
				tempCenter1.plan1 = '是'
				tempCenter = {
					insuredItem: '扩展伤残赔偿比例十级标准',
					plan1:
						'本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T 16180-2014）进行伤残等级鉴定，给付比例一级到十级分别为：100%，80%，70%，60%，50%，40%，30%，25%，15%，10%；',
				}
			}
			let tempData = this.deepClone(this.dataPlanTemp)
			tempData.push(tempCenter1)
			tempData.push(tempCenter)
			//处理钱
			let tempPrice = this.priceRate === 1 ? this.deepClone(this.priceData1) : this.deepClone(this.priceData2)
			//扩展了 要乘以 1.1
			let tempKuozhanRate = this.kuozhanRate === 2 ? 1.1 : 1

			tempPrice.forEach((itemData) => {
				for (let i = 1; i <= 8; i++) {
					itemData[`plan${i}`] = (itemData[`plan${i}`] * tempKuozhanRate).toFixed(2)
				}
			})
			tempData = tempData.concat(this.deepClone(tempPrice))

			let tempMonth = [1, 3, 6]
			for (let number of tempMonth) {
				let tempPriceFor = this.deepClone(tempPrice)
				let tempMothPrice = tempPriceFor.map((itemData, index) => {
					let tempLei = ''
					switch (index) {
						case 0:
							tempLei = '1-2'
							break
						case 1:
							rate = 10
							tempLei = '3'
							break
						case 2:
							rate = 10
							tempLei = '4'
							break
					}
					let rate = 0
					let insuredItem = `${tempLei}类职业（元/${number}个月）`
					switch (number) {
						case 1:
							rate = 10
							break
						case 3:
							rate = 3.3333333333
							break
						case 6:
							rate = 1.6666666666
							break
					}
					itemData.insuredItem = insuredItem
					for (let i = 1; i <= 8; i++) {
						itemData[`plan${i}`] = (itemData[`plan${i}`] / rate).toFixed(2)
					}
					return itemData
				})
				tempData = tempData.concat(tempMothPrice)
			}
			this.dataPlan = tempData
			// let tempMothPrice = tempPrice.map((itemData,index) => {
			//     let rate = 0
			//     let insuredItem = ''
			//     switch (index) {
			//         case 0:
			//             rate = 10
			//             insuredItem = '1个月保单保费'
			//             break
			//         case 1:
			//             rate = 3.3333333333
			//             insuredItem = '3个月保单保费'
			//             break
			//         case 2:
			//             rate = 1.6666666666
			//             insuredItem = '6个月保单保费'
			//             break
			//     }
			//     itemData.insuredItem = insuredItem
			//     for (let i = 1; i <=8 ; i++) {
			//         itemData[`plan${i}`] = (itemData[`plan${i}`] / rate).toFixed(2)
			//     }
			//     return itemData
			// })
		},
		onCellStyle({row, column}) {
			if (row.$index === 6) {
				return {
					color: 'red',
				}
			}
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 3 || rowIndex === 4 || rowIndex === 5 || rowIndex === 6 || rowIndex === 7) {
				if (columnIndex === 1) {
					return [1, 11]
				}
			}
			// if (columnIndex === 0) {
			//     if (rowIndex >= 9 && rowIndex <= 16) {
			//         if (columnIndex === 0) {
			//             if (rowIndex % 2 === 1) {
			//                 return {
			//                     rowspan: 2,
			//                     colspan: 1
			//                 }
			//             } else {
			//                 return {
			//                     rowspan: 0,
			//                     colspan: 0
			//                 }
			//             }
			//         }
			//     }
			// }
			// if (rowIndex > 17) {
			//     if (columnIndex === 2) {
			//         // return [1, 11]
			//         return {
			//             rowspan: 3,
			//             colspan: 4
			//         }
			//     } else if (columnIndex > 2) {
			//         return {
			//             rowspan: 0,
			//             colspan: 0
			//         }
			//     }
			// }
			//
			// if (rowIndex < 9) {
			//     if (columnIndex === 0) {
			//         return [1, 2]
			//     } else if (columnIndex === 1) {
			//         return [0, 0]
			//     }
			// }
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `qh_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		onChangePriceRate(value) {
			if (this.priceRate !== value) {
				this.priceRate = value
			}
			this.dealPrice()
		},
		onChangeKuozhanRate(value) {
			if (this.kuozhanRate !== value) {
				this.kuozhanRate = value
			}
			this.dealPrice()
		},
	},
}
</script>

<style lang="scss" scoped>
.red-bold {
	color: red;
	font-weight: bold;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
